import { Box, List } from 'lucide-react';
import { LayoutType } from '../types/prayer';

interface LayoutQuickToggleProps {
  layout: LayoutType;
  onToggle: () => void;
}

export function LayoutQuickToggle({ layout, onToggle }: LayoutQuickToggleProps) {
  const is3DView = layout === 'cards';

  return (
    <button
      onClick={onToggle}
      className="fixed top-16 left-4 z-50 flex items-center gap-2 bg-white/20 hover:bg-white/30 backdrop-blur-md text-white px-4 py-2 rounded-full shadow-lg transition-all border border-white/30"
      aria-label="Toggle 3D cards view"
      title={is3DView ? "Switch to List View" : "Switch to 3D Cards"}
    >
      {is3DView ? (
        <>
          <List className="w-5 h-5" />
          <span className="hidden sm:inline font-semibold">List View</span>
        </>
      ) : (
        <>
          <Box className="w-5 h-5" />
          <span className="hidden sm:inline font-semibold">3D Cards</span>
        </>
      )}
    </button>
  );
}
